import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SplitPane } from 'react-multi-split-pane';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { saveAs } from 'file-saver';

// Estilos
import 'react-perfect-scrollbar/dist/css/styles.css';
import './AtlasPacker.scss';
import 'animate.css';

// Componentes
import MenuComponent from './components/menu/Menu';
import CardImage from './components/cardImage/CardImage';
import ContextMenu from './components/contextMenu/ContextMenu';
import ExportButton from './components/exportButtons/ExportButton';
import Zoom from './components/zoom/Zoom';
import Algorithm from './components/algorithm/Algorithm';
import Render from './components/render/Render';

// Redux
import { CloseSideContextMenuAction } from '../../Redux/Actions/Atlas/contextSideMenu.action';
import store from '../../Redux/Store/store';
import { Observer, GLOBAL_EVENT, ImageCanvasData } from './Observer';
import ExportModal from './components/modals/exportModal/ExportModal';

// UI
import createExportZipAtlas from '../../utils/createExportZipAtlas';
import ImportAtlas from './components/modals/importAtlas/ImportAtlas';
import { DesSelectImage, ResetImage } from '../../Redux/Actions/Atlas/images.action';
import ToastNotification from './components/notifications/ToastNotification';
import DragDropFiles from './components/dragDropFiles/DragDropFiles';
import { ResetAlgorithmAction } from '../../Redux/Actions/Atlas/algorithmPanel.action';
import { ResetMaxRectAction } from '../../Redux/Actions/Atlas/maxrect.action';
import { ResetZoomAction } from '../../Redux/Actions/Atlas/zoom.action';
import SpinnerModal from './components/modals/spinnerModal/SpinnerModal';
import ImportGifs from './components/modals/importGifs/ImportGifs';
import PatreonModal from './components/modals/patreonModal/PatreonModal';

let _scrollBarRef: any;

interface dispatchInterface {
    CloseSideContextMenuAction: () => {};
    DesSelectImage: () => {};
    ResetImage: () => {};
    ResetAlgorithmAction: () => {};
    ResetMaxRectAction: () => {};
    ResetZoomAction: () => {};
}

class AtlasPacker extends Component<dispatchInterface, { exportModalOpen: boolean }> {
    constructor(props: any) {
        super(props);
        this.state = {
            exportModalOpen: false,
        };
        Observer.removeAllListeners();
    }

    handleClickContainerAtlas = () => {
        if (store.getState().contextSideMenuAtlas.active) {
            this.props.CloseSideContextMenuAction();
        }
        Observer.emit(GLOBAL_EVENT.IMAGE_DES_SELECTED);
        this.props.DesSelectImage();
    };

    UNSAFE_componentWillMount() {
        this.props.ResetImage();
        this.props.ResetAlgorithmAction();
        this.props.ResetMaxRectAction();
        this.props.ResetZoomAction();

        Observer.removeAllListeners();
    }

    componentDidMount() {
        Observer.on(
            GLOBAL_EVENT.IMAGE_CANVAS_EXPORTED,
            async (image_canvas_data: ImageCanvasData) => {
                const zip = createExportZipAtlas(image_canvas_data);
                const file = await zip.generateAsync({ type: 'blob' });
                saveAs(file, `${image_canvas_data.name}.zip`);
            }
        );
    }

    render() {
        return (
            <React.Fragment>
                <SpinnerModal />
                <ToastNotification />

                <div
                    className="principal-container"
                    onContextMenu={(event) => event.preventDefault()}
                    onClickCapture={this.handleClickContainerAtlas}
                    onDrop={(e) => e.preventDefault()}
                    onDragOver={(e) => e.preventDefault()}
                >
                    <MenuComponent />
                    <SplitPane
                        split="vertical"
                        className="panels-container"
                        defaultSizes={[20, 60, 20]}
                        minSize={[200, 500, 200]}
                        onDragFinished={() => Observer.emit(GLOBAL_EVENT.PANEL_RESIZE_END)}
                    >
                        <DragDropFiles className="left-panel">
                            <div className="left-panel--image_container">
                                <PerfectScrollbar
                                    options={{ suppressScrollX: true }}
                                    className="texto"
                                    ref={(ref) => {
                                        _scrollBarRef = ref;
                                    }}
                                >
                                    <CardImage />
                                </PerfectScrollbar>
                            </div>
                        </DragDropFiles>
                        <div className="center-panel">
                            <div className="center-panel--up">
                                <Render />
                            </div>
                            <div className="center-panel--down">
                                <Zoom />
                            </div>
                        </div>
                        <div className="right-panel">
                            <div className="right-panel--up">
                                <Algorithm />
                            </div>
                            <div className="right-panel--down">
                                <ExportButton
                                    title="Export"
                                    handleClick={() => {
                                        Observer.emit(GLOBAL_EVENT.OPEN_EXPORT_OPTIONS_PC);
                                    }}
                                />
                                <div className="d-none">
                                    <ExportButton
                                        title="Save in game"
                                        handleClick={() => {
                                            Observer.emit(
                                                GLOBAL_EVENT.NOTIFICATION_SYSTEM.WARNING,
                                                'This is not a correct Atlas Phaser format'
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </SplitPane>
                    <ContextMenu
                        onUpdateSize={() => {
                            _scrollBarRef.updateScroll();
                        }}
                    />
                </div>
                <ExportModal />
                <ImportAtlas />
                <ImportGifs />
                <PatreonModal />
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = {
    CloseSideContextMenuAction,
    DesSelectImage,
    ResetImage,
    ResetAlgorithmAction,
    ResetMaxRectAction,
    ResetZoomAction,
};

export default connect(null, mapDispatchToProps)(AtlasPacker);
